import { Message } from "element-ui";

//图片上传前校验
const checkImguploadBanner = (params) => {
  const isJPG = params.typeArr.indexOf(params.file.type) > -1 ? true : false;
  const isMaxsize = params.isMaxsize;
  if (!isMaxsize) {
    Message.error(params.sizeMessage);
    return false;
  }
  if (!isJPG) {
    Message.error(params.imgMessage);
    return false;
  }
  if (isJPG && params.file.type != "application/pdf") {
    let imgWidth = "";
    let imgHight = "";
    console.log(imgWidth, imgHight);
    const isSize = new Promise(function(resolve, reject) {
      let width = params.maxWidth;
      let height = params.maxHeight;
      let _URL = window.URL || window.webkitURL;
      let img = new Image();
      img.onload = function() {
        imgWidth = img.width;
        imgHight = img.height;
        if ((imgWidth <= width && imgHight <= height) || (imgWidth === 1668 && imgHight === 692)) {
          resolve();
        } else {
          reject();
        }
      };
      img.src = _URL.createObjectURL(params.file);
    }).then(
      () => {
        return params.file;
      },
      () => {
        Message.warning({
          message: `上传文件的图片大小不符合标准,图片宽度应小于${params.maxWidth}px，图片高度应小于${params.maxHeight}px`,
          btn: false,
        });
        return Promise.reject();
      }
    );
    return isSize;
  }
  return isJPG && isMaxsize;
};

export default {
  checkImguploadBanner,
};
